module.exports = function(app) {
    'use strict';
    app.directive('recentDocumentAlerts', ['teamsite', 'services', '$window', 'invisibleForm', 'sessionData',
        function (teamsite, services, $window, invisibleForm, sessionData) {
            return {
                restrict: 'A',
                replace: false,
                transclude: true,
                template: require('directives/employee/recentDocumentAlerts.html'),
                scope:{
                   alerts: '=recentDocumentAlerts'
                },
                controller: [function () {
                }],
                link: function (scope) {
                    scope.brandName = sessionData.employerInfo.brandName;
                    scope.callingPage = {
                        isRecentDocs: false,
                    };

                    var getItemsFromService = function () {
                        // TODO: name the variables more generically
                        // TODO: b c this is used in three pages, not just Bene Books
                        scope.serviceCallIsRunning = true;
                        scope.serviceReturnedItems = false;
                        //if (scope.callingPage.isalerts) {
                            services.eprsvc.alerts().submitSearch().then(function (retObj) {
                                if(retObj && retObj.data && retObj.data.payload ) {
                                    scope.bkAlertC = retObj.data.payload['bookletAlertCounter'];
                                    scope.coAlertC = retObj.data.payload['contractAlertCounter'];
                                    scope.coRiderC = retObj.data.payload['contractRiderCounter'];
                                    scope.bkRiderC = retObj.data.payload['bookletRiderCounter'];
                                }
                            },function(error){
                                scope.bkAlertC=0;
                                scope.coAlertC=0;
                                scope.coRiderC=0;
                                scope.bkRiderC = 0;
                            });
                    }
                       // }
                    getItemsFromService();
                }
            };
        }]);
}


